import { FC, useRef, useState, useEffect } from 'react';
import SupplierDatabase from '../app-supplier-database/supplier-database';
import { serviceAreas } from '../../services/service-areas';
import { ServiceSupplier } from '../../services/service-supplier';
import styles from './page-area-supplier-assign.module.scss';
import { useHistory } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';

type PageAreaSupplierAssignProps = {
  showLoading: boolean;
  onSaveClick: () => void;
  match: any;
  area?: { label: string; value: string };
  t: any;
}

const PageAreaSupplierAssign: FC<PageAreaSupplierAssignProps> = ({
  showLoading,
  match,
  area: routeArea,
  t
}) => {
  const [suppliers, setSuppliers] = useState<string[]>([]);
  const [previousSuppliers, setPreviousSuppliers] = useState([]);
  const supplierDatabaseInstance = useRef();
  const [area, setArea] = useState<any>(routeArea);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchAreaAndAssignedSuppliers = async () => {
      if (match?.params?.areaId) {

        if (!routeArea) {
          const allAreas = await serviceAreas.getAreas();
          const foundArea = allAreas?.find((a: any) => a._id === match.params.areaId);
          if (foundArea) {
            setArea({ label: foundArea.name, value: foundArea._id });
          }
        }
        const filteredSuppliers = await ServiceSupplier.fetchSupplier({ areaId: match.params.areaId });
        setPreviousSuppliers(filteredSuppliers.data);
      }
      setLoading(false);
    };
    fetchAreaAndAssignedSuppliers();
  }, [match?.params?.areaId, routeArea]);

  const selectEventHandler = (selectedSupplier: any) => {
    setSuppliers(selectedSupplier);
  };

  const initialSupplierIds = previousSuppliers.map((s: any) => s.sup_id);
  const hasChanges =
    initialSupplierIds.length !== suppliers.length ||
    suppliers.some((id: string) => !initialSupplierIds.includes(id)) ||
    initialSupplierIds.some((id: string) => !suppliers.includes(id));

  const elSaveClickCallback = async () => {
    setSaving(true);
    const mappedSuppliers = previousSuppliers.map((supplier: any) => supplier.sup_id);
    const suppliersToRemove = mappedSuppliers.filter((supplier: any) => !suppliers.includes(supplier));
    const suppliersToAdd = suppliers.filter((supplier: any) => !mappedSuppliers.includes(supplier));

    if (!suppliersToRemove?.length && !suppliersToAdd?.length) {
      setSaving(false);
      NotificationManager.error(t('notification.error.unexpected.title', 'Misslyckat'), t('notification.error.unexpected.noChanges', 'Inga ändringar att spara'));
      return;
    }

    try {
      if (suppliersToRemove?.length > 0) {
        for (const supplier of suppliersToRemove) {
          await ServiceSupplier.removeSupplierArea({ supplierId: supplier, area: area?.value });
        }
      }

      if (suppliersToAdd?.length > 0) {
        for (const supplier of suppliersToAdd) {
          await ServiceSupplier.addSupplierArea({ supplierId: supplier, area: area?.value });
        }
    }
    } catch (error) {
      NotificationManager.error(t('notification.error.unexpected.title', 'Misslyckat'), t('notification.error.unexpected.description', 'Något gick fel'));
      setSaving(false);
      return;
    }
    setSaving(false);
    NotificationManager.success(t('notification.success.saved', 'Ändringar sparade'));
    history.goBack();
  };

  return !loading ? (
    <div className={styles.container}>
      <SupplierDatabase
        ref={supplierDatabaseInstance}
        key={1}
        areaName={area?.label}
        selectMode={true}
        selectEvent={selectEventHandler}
        onSaveSelectedSuppliersClick={elSaveClickCallback}
        showLoading={showLoading || saving}
        previousSuppliers={previousSuppliers}
        canRemoveSuppliers={true}
        saveDisabled={!hasChanges}
        backButtonUrl={`/settings/categories`}
      />
    </div>
  ) : null;
};

export default PageAreaSupplierAssign;
